
function setCookie(name, value, expires, path, domain, secure) {
  var today = new Date();
  today.setTime(today.getTime());
  if (expires) {
    expires = expires * 1000 * 60 * 60 * 24;
  }
  var expires_date = new Date(today.getTime() + (expires));
  document.cookie = name + "=" + escape(value) +
    ((expires) ? ";expires=" + expires_date.toGMTString() : "") +
    ((path) ? ";path=" + path : "") +
    ((domain) ? ";domain=" + domain : "") +
    ((secure) ? ";secure" : "");
}

function getCookie(check_name) {
  var a_all_cookies = document.cookie.split(';');
  var a_temp_cookie = '';
  var cookie_name = '';
  var cookie_value = '';
  var b_cookie_found = false;
  for (var i = 0; i < a_all_cookies.length; i++) {
    a_temp_cookie = a_all_cookies[i].split('=');
    cookie_name = a_temp_cookie[0].replace(/^\s+|\s+$/g, '');
    if (cookie_name == check_name) {
      b_cookie_found = true;
      if (a_temp_cookie.length > 1) {
        cookie_value = unescape(a_temp_cookie[1].replace(/^\s+|\s+$/g, ''));
      }
      return cookie_value;
    }
    a_temp_cookie = null;
    cookie_name = '';
  }
  if (!b_cookie_found) {
    return null;
  }
}

function Set_Cookie( name, value, expires, path, domain, secure ) {
	setCookie(name, value, expires, path, domain, secure);
}

function delen_sh(url,title) { /* Webshare API */
	deel_url=url || document.URL;
	deel_title=title || document.title;
	navigator.share({ title:deel_title, url:deel_url }); 
}

/* Start Meganavbar */

/* Start navbar toggle fix top bottom */

document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.toggle_fixing');
    if (!trigger) return;

    e.preventDefault();

    const navbar = document.getElementById('main_navbar');
    const icon = trigger.querySelector('i');
    const navHeightValue = navbar.offsetHeight; // Use offsetHeight for total height

    if (navbar.classList.contains('navbar-fixed-top')) {
        // Toggle classes on Navbar
        navbar.classList.toggle('navbar-fixed-bottom');
        navbar.classList.toggle('navbar-fixed-top');
        
        // Toggle classes on Icon
        if (icon) {
            icon.classList.toggle('fa-chevron-down');
            icon.classList.toggle('fa-chevron-up');
        }
    } else {
        navbar.classList.toggle('navbar-fixed-bottom');
        
        if (icon) {
            icon.classList.toggle('fa-chevron-down');
            icon.classList.toggle('fa-chevron-up');
        }

        const parent = navbar.parentElement;
        const childDiv = navbar.querySelector('div'); // Targets the first child div

        if (childDiv) {
            if (parent.classList.contains('container')) {
                childDiv.classList.add('container');
                childDiv.classList.remove('container-fluid');
            } else if (parent.classList.contains('container-fluid')) {
                childDiv.classList.add('container-fluid');
                childDiv.classList.remove('container');
            }
        }
        
		FixMegaNavbar(navHeight); 
    }

    if (navbar.classList.contains('navbar-fixed-top')) {
        document.body.style.marginTop = navHeightValue + 'px';
        document.body.style.marginBottom = '';
    } else if (navbar.classList.contains('navbar-fixed-bottom')) {
        document.body.style.marginBottom = navHeightValue + 'px';
        document.body.style.marginTop = '';
    }
});

/* End navbar toggle fix top bottom */

/* Start Fix MegaNavbar on scroll page */

const navbar = document.getElementById('main_navbar');

if (navbar) {
    const navHeight = navbar.getBoundingClientRect().top + window.scrollY;
    let ticking = false; // The flag to prevent over-firing

    window.addEventListener('scroll', function() {
        if (!ticking) {
            // requestAnimationFrame syncs with the browser's refresh rate
            window.requestAnimationFrame(function() {
                FixMegaNavbar(navHeight);
                ticking = false;
            });

            ticking = true;
        }
    }, { passive: true }); // 'passive' improves scroll performance
}

function FixMegaNavbar(navHeight) {
    const navbar = document.getElementById('main_navbar');
    if (!navbar) return;

    if (!navbar.classList.contains('navbar-fixed-bottom')) {
        const body = document.body;
        const logo1 = document.querySelectorAll('.logo1');
        const childDiv = navbar.querySelector('div');
        const parent = navbar.parentElement;

        if (window.scrollY > navHeight) {
            // "Sticky" Mode On
            navbar.classList.add('navbar-fixed-top');
            
            // body.style.marginTop = navbar.offsetHeight + 'px';
            body.style.marginTop = '50px'; 

            for (var i = 0; i < logo1.length; i++) {
                logo1[i].style.marginLeft = '16px';
            }

            if (childDiv) {
                if (parent && parent.classList.contains('container')) {
                    childDiv.classList.add('container');
                    childDiv.classList.remove('container-fluid');
                } else if (parent && parent.classList.contains('container-fluid')) {
                    childDiv.classList.add('container-fluid');
                    childDiv.classList.remove('container');
                }
            }
        } else {
            // "Sticky" Mode Off
            navbar.classList.remove('navbar-fixed-top');

            if (childDiv) {
                childDiv.classList.add('container-fluid');
                childDiv.classList.remove('container');
            }

            body.style.marginTop = '';
			for (var i = 0; i < logo1.length; i++) {
                logo1[i].style.marginLeft = '-200px';
            }
        }
    }
}
// End Fix MegaNavbar on scroll page

// Custom Bootstrap 5 replacements (dropdowns, collapse, search tabs).
// Bootstrap 5 dropped jQuery and we deliberately do NOT load bootstrap.js,
// so this drives the navbar with BS5 class conventions (.show) ourselves.
(function() {
    function closeAllDropdowns(except) {
        document.querySelectorAll('.navbar .nav-item.show, .navbar .dropdown.show').forEach(function(li) {
            if (li === except) return;
            li.classList.remove('show');
            var m = li.querySelector('.dropdown-menu');
            if (m) m.classList.remove('show');
            var t = li.querySelector('[data-toggle="dropdown"]');
            if (t) t.setAttribute('aria-expanded', 'false');
        });
    }

    document.addEventListener('click', function(e) {
        // Dropdown toggle — BS5 shows menus via .show on the menu (and we add it
        // to the parent .nav-item/.dropdown for the skin's open-state styling).
        var toggle = e.target.closest('[data-toggle="dropdown"]');
        if (toggle) {
            e.preventDefault();
            var li = toggle.closest('.nav-item, .dropdown');
            var menu = toggle.nextElementSibling;
            var willOpen = !(li && li.classList.contains('show'));
            closeAllDropdowns(li);
            if (li) li.classList.toggle('show', willOpen);
            if (menu) menu.classList.toggle('show', willOpen);
            toggle.setAttribute('aria-expanded', String(willOpen));
            return;
        }

        // Collapse toggle (mobile navbar) — BS5 uses .show; sync the hamburger.
        var collapseToggle = e.target.closest('[data-toggle="collapse"]');
        if (collapseToggle) {
            e.preventDefault();
            var sel = collapseToggle.getAttribute('data-target') || collapseToggle.getAttribute('href');
            var el = sel ? document.querySelector(sel) : null;
            if (el) {
                var willShow = !el.classList.contains('show');
                el.classList.toggle('show', willShow);
                collapseToggle.classList.toggle('is-active', willShow);
                collapseToggle.setAttribute('aria-expanded', String(willShow));
            }
            return;
        }

        // Category submenu flyout (tap/click; desktop also opens on :hover via CSS).
        var sub = e.target.closest('[data-toggle="submenu"]');
        if (sub) {
            e.preventDefault();
            e.stopPropagation();
            var sm = sub.nextElementSibling;
            if (sm) {
                var subOpen = sm.classList.contains('show');
                var catMenu = sub.closest('.cat-menu');
                if (catMenu) catMenu.querySelectorAll('.dropdown-menu.show').forEach(function(o){ if (o !== sm) o.classList.remove('show'); });
                sm.classList.toggle('show', !subOpen);
            }
            return;
        }

        // Search panel tabs (replaces the old data-slide-to carousel).
        var tab = e.target.closest('.search-tabs [data-tab]');
        if (tab) {
            e.preventDefault();
            var i = tab.getAttribute('data-tab');
            var menu = tab.closest('.search-menu');
            if (menu) {
                menu.querySelectorAll('.search-tabs .nav-link').forEach(function(x){ x.classList.remove('active'); });
                tab.classList.add('active');
                menu.querySelectorAll('.search-pane').forEach(function(p){
                    p.classList.toggle('active', p.getAttribute('data-pane') === i);
                });
            }
            return;
        }

        // Click outside any open dropdown menu closes the dropdowns.
        if (!e.target.closest('.dropdown-menu')) closeAllDropdowns();
    });
})();

/* End Meganavbar */
